import type { positionForRole } from './positions';

type Position = ReturnType<typeof positionForRole>;

/**
 * The onboarding steps for each outreach method (the portal's shared/outreachMethods.ts keys). The
 * steps a position has today are Cold Call's; a new outreach method adds its own steps here.
 */
const WORKFLOW_BY_OUTREACH_METHOD: Record<string, (position: Position) => Position['workflow']> = {
  COLD_CALL: (position) => position.workflow,
};

export function workflowFor(position: Position, outreachMethod: string | null | undefined): Position['workflow'] {
  return (WORKFLOW_BY_OUTREACH_METHOD[outreachMethod ?? ''] ?? WORKFLOW_BY_OUTREACH_METHOD.COLD_CALL!)(position);
}
